import {
	Children,
	FC,
	isValidElement,
	cloneElement,
	useState,
	useEffect,
	ReactElement,
} from "react";
import BemIt from "@gtechdoodler/bem-it";

import Box from "../../../layout/boxes/Box";

import AccordionTitle from "../AccordionTitle/AccordionTitle";
import AccordionContent from "../AccordionContent/AccordionContent";
import { AccordionItemProps } from "./AccordionItem.types";
import { StyledAccordionItemDivider } from "./AccordionItem.styles";
import { AccordionTitleProps } from "../AccordionTitle/AccordionTitle.types";
import { AccordionContentProps } from "../AccordionContent/AccordionContent.types";

const AccordionItem: FC<AccordionItemProps> = ({
	children,
	colorOn,
	isOpen = false,
	onToggle,
}) => {
	const block = new BemIt("AccordionItem");

	const [isItemOpen, setIsItemOpen] = useState<boolean>(false);

	const handleItemToggle = () => {
		setIsItemOpen(!isItemOpen);
		if (onToggle) onToggle(isItemOpen);
	};

	const childrenWithProps = Children.map(children, (child) => {
		if (isValidElement(child)) {
			const isTitle = child.type === AccordionTitle;
			const isContent = child.type === AccordionContent;

			if (!isTitle && !isContent) {
				console.error(
					`Invalid Accordion.Item subcomponent: The child you provided is not a valid Accordion.Item subcomponent, please provide Accordion.Title and Accordion.Content subcomponents`
				);
				return null;
			}

			return cloneElement(
				child as ReactElement<AccordionTitleProps | AccordionContentProps>,
				{
					colorOn,
					isOpen: isItemOpen,
					...(isTitle && {
						onClick: handleItemToggle,
					}),
				}
			);
		}
	});

	useEffect(() => {
		setIsItemOpen(isOpen);
	}, [isOpen]);

	return (
		<Box position="relative" className={block.mod(isOpen ? "open" : "").out}>
			<StyledAccordionItemDivider colorOn={colorOn} />
			{childrenWithProps}
		</Box>
	);
};

export default AccordionItem;
